import { useCallback, useState } from 'react'

import { download } from '@/services/units/download'

export const useUnitCollectDownloadOptions = () => {
  const [isLoading, setIsLoading] = useState(false)

  const downloadOptions = useCallback(async (collectId: string) => {
    try {
      setIsLoading(true)
      const data = await download(collectId)

      return data
    } catch (error) {
      console.error('Error download spreadsheet:', error)
      return null
    } finally {
      setIsLoading(false)
    }
  }, [])

  return { downloadOptions, isLoading }
}
